import styles from '../shared/mhlShared.module.scss'
import type { IdentityDoc, IdentityDocKind } from '../shared/mhlTypes'
import { AudiogramViewer } from './AudiogramViewer'

const SLOTS: Array<{ kind: IdentityDocKind; label: string }> = [
    { kind: 'poid', label: 'Proof of ID' },
    { kind: 'utility_bill', label: 'Utility bill' },
]

interface Props {
    caseRef: string
    docs: IdentityDoc[]
    hideHeading?: boolean
}

export const IdentityDocumentsSection = ({ caseRef, docs, hideHeading = false }: Props) => {
    const uploaded = SLOTS.filter((slot) => docs.some((doc) => doc.kind === slot.kind)).length

    return (
        <div className={styles.identityBlock}>
            {!hideHeading && (
                <>
                    <div className={styles.divider} />
                    <div className={styles.subTitle}>Identity documents</div>
                </>
            )}
            <p className={styles.hint}>
                {uploaded === 0
                    ? 'Proof of ID and utility bill have not been uploaded yet.'
                    : `${uploaded} of 2 identity documents uploaded.`}
            </p>
            <div className={styles.identitySlots}>
                {SLOTS.map((slot) => {
                    const doc = docs.find((item) => item.kind === slot.kind) || null
                    return (
                        <div key={slot.kind}>
                            <div className={styles.subTitle}>{slot.label}</div>
                            <AudiogramViewer
                                caseRef={caseRef}
                                doc={doc}
                                canUpload={false}
                                emptyCopy={`${slot.label} has not been uploaded.`}
                                previewAriaLabel={`${slot.label} review`}
                            />
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
